import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material'
import { UserBlockWrapper } from './styled'
import { toast } from 'react-toastify';
import IconButton from '@mui/material/IconButton'
import { axiosClient } from '../../core';
import PhotoCamera from '@mui/icons-material/PhotoCamera'
import UserBlock from "./user-block";

const SidebarBottomBlock = ({ currentUser }) => {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [description, setDescription] = useState('')
  const [mediaFile, setMediaFile] = useState(null)
  const closeDialog = () => {
    setIsDialogOpen(false)
    setDescription('')
    setMediaFile(null)
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    setMediaFile(file)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('description', description);
    if (mediaFile) {
      formData.append('media', mediaFile);
    }

    try {
      await axiosClient.post('/reports/problems', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success(t('reportProblem.successMessage', 'Сообщение отправлено успешно'));
      closeDialog();
    } catch (error) {
      toast.error(error?.response?.data?.detail || t('errorMessages.generic', 'Произошла ошибка'));
    }
  };

  return (
      <>
        <UserBlockWrapper>
          <UserBlock currentUser={currentUser} />
        </UserBlockWrapper>

        <Dialog open={isDialogOpen} onClose={closeDialog} fullWidth maxWidth="sm">
          <DialogTitle>{t('reportProblem.title', 'Сообщить о проблеме')}</DialogTitle>
          <DialogContent dividers>
            <TextField
                label={t('reportProblem.description', 'Описание проблемы')}
                multiline
                rows={4}
                fullWidth
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                margin="normal"
            />
            <input
                accept="image/*,video/*"
                style={{ display: 'none' }}
                id="report-media-file"
                type="file"
                onChange={handleFileChange}
            />
            <label htmlFor="report-media-file">
              <IconButton color="primary" component="span">
                <PhotoCamera />
              </IconButton>
              {mediaFile ? mediaFile.name : t('reportProblem.uploadMedia', 'Прикрепить файл (фото, видео)')}
            </label>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDialog} variant="outlined">
              {t('buttons.cancel')}
            </Button>
            <Button type="submit" variant="contained" onClick={handleSubmit} disabled={!description && !mediaFile}>
              {t('buttons.send', 'Отправить')}
            </Button>
          </DialogActions>
        </Dialog>
      </>
  )
}

export default SidebarBottomBlock
